"use client"

import { Badge, CheckIcon, Group, type GroupProps, type MantineColor, Radio, type RadioCardProps, rem, Stack, Text, type TextProps } from "@mantine/core"
import classes from "./RadioCard.module.css"
import { useMemo } from "react"

interface IRadioCardProps {
  checked: boolean
  checkIcon?: typeof CheckIcon | null
  label: string
  description?: string
  badge?: {
    text: string
    color?: MantineColor
  }
  props?: {
    card?: RadioCardProps
    container?: GroupProps
    label?: TextProps
    description?: TextProps
  }
  onClick?: (isChecked: boolean) => void
  disabled?: boolean
}

export function RadioCard({ checked, checkIcon, label, description, props, onClick, badge, disabled }: IRadioCardProps) {
  const Icon = useMemo(() => {
    if (checkIcon === null) {
      return undefined
    }

    if (checkIcon) {
      return checkIcon
    }

    return CheckIcon
  }, [checkIcon])

  return (
    <Radio.Card
      className={classes.root}
      radius="md"
      {...props?.card}
      checked={checked}
      onClick={() => {
        if (onClick) {
          onClick(!checked)
        }
      }}
      disabled={disabled}
    >
      <Group wrap="nowrap" align="flex-start" {...props?.container}>
        <Radio.Indicator icon={Icon} />
        <Group align="flex-start" justify="space-between" w="100%">
          <Stack gap={rem(2)}>
            <Text size="lg" className={classes.label} {...props?.label}>
              {label}
            </Text>
            {description && (
              <Text className={classes.description} {...props?.description}>
                {description}
              </Text>
            )}
          </Stack>
          {badge && <Badge color={badge.color}>{badge.text}</Badge>}
        </Group>
      </Group>
    </Radio.Card>
  )
}
